import { Users, Inbox, ShieldCheck, Package, UserPlus, ShieldAlert, Wallet, ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

const META = {
  providers: { icon: Users, label: "kpi.providers" },
  inquiries7d: { icon: Inbox, label: "kpi.inquiries7d" },
  approvals: { icon: ShieldCheck, label: "kpi.approvals" },
  subscriptions: { icon: Package, label: "kpi.subscriptions" },
  registrations7d: { icon: UserPlus, label: "kpi.registrations7d" },
  security: { icon: ShieldAlert, label: "kpi.security" },
  revenue: { icon: Wallet, label: "kpi.revenue" },
};

const TONE = {
  neutral: "#a1a1aa",
  info: "#3b82f6",
  warning: "#f59e0b",
  success: "#10b981",
  danger: "#f43f5e",
};

function Trend({ trend, t }) {
  if (!trend) return null;
  const { dir, prev } = trend;
  const Icon = dir === "up" ? ArrowUpRight : dir === "down" ? ArrowDownRight : Minus;
  const color = dir === "up" ? "#10b981" : dir === "down" ? "#f43f5e" : "#71717a";
  const delta = trend.delta > 0 ? `+${trend.delta}` : `${trend.delta}`;
  return (
    <span className="inline-flex items-center gap-1 text-xs font-medium" style={{ color }} title={`${t("kpi.vsPrev")}: ${prev}`}>
      <Icon className="h-3.5 w-3.5" />
      {delta}
    </span>
  );
}

export function KPIRow({ kpis = [], t }) {
  return (
    <div
      data-testid="control-kpi-row"
      className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7"
    >
      {kpis.map((k, i) => {
        const meta = META[k.key] || { icon: Minus, label: k.key };
        const Icon = meta.icon;
        const tone = TONE[k.tone] || TONE.neutral;
        const display = k.unit === "CHF" ? `CHF ${(k.value ?? 0).toLocaleString("de-CH")}` : (k.value ?? 0).toLocaleString("de-CH");
        return (
          <div
            key={k.key}
            data-testid={`kpi-${k.key}`}
            className="group relative overflow-hidden rounded-xl border border-zinc-800 bg-zinc-900/60 p-4 transition-colors hover:bg-zinc-900"
            style={{ animationDelay: `${i * 40}ms` }}
          >
            <span className="absolute left-0 top-0 h-full w-1" style={{ background: tone, opacity: 0.7 }} />
            <div className="flex items-center justify-between">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-zinc-800/80" style={{ color: tone }}>
                <Icon className="h-4 w-4" />
              </div>
              <Trend trend={k.trend} t={t} />
            </div>
            <div className="mt-3 font-mono text-xl font-bold tracking-tight text-white" data-testid={`kpi-${k.key}-value`}>{display}</div>
            <div className="mt-1 text-[11px] font-medium leading-tight text-zinc-500">{t(meta.label)}</div>
          </div>
        );
      })}
    </div>
  );
}
